/**
 * แปลง image path จาก backend ให้เป็น full URL
 * @param {string} path - image path จาก API (เช่น /storage/products/xxx.jpg หรือ parcels/xxx.jpg)
 * @returns {string} - full URL ของรูปภาพ
 */
export function getImageUrl(path) {
  console.log('getImageUrl input:', path);
  if (!path) return null;
  
  // ถ้าเป็น full URL ให้แปลงเป็น relative path เพื่อหลีกเลี่ยงปัญหา cross-origin
  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path);
      // ใช้แค่ pathname (เช่น /storage/products/xxx.jpg)
      console.log('getImageUrl output:', url.pathname);
      return url.pathname;
    } catch (e) {
      console.log('getImageUrl error:', e);
      return path;
    }
  }
  
  // ถ้า path ไม่ได้ขึ้นต้นด้วย / ให้เพิ่ม /storage/
  if (!path.startsWith('/')) {
    const result = `/storage/${path}`;
    console.log('getImageUrl output:', result);
    return result;
  }
  
  console.log('getImageUrl output:', path);
  return path;
}

export default getImageUrl;
